/* eslint-disable */
import { CommonGet, CommonPost } from '../../../helpers/HttpClient';

export default {
    GetProductDetails,
    GetAllGroups,
    GetProductCategoties,
    GetProductTypes,
    GetFactoriesByGroupID,
    GetCropWiseCropForecast,
    GetCropForecastByOperationEntityID,
    GetCropForecastByCropID
    
   
};

async function GetProductCategoties() {
    const response = await CommonGet('/api/ProductCategory/GetProductCategoryDetails', null);
    return response.data;
}

async function GetProductTypes() {
    const response = await CommonGet('/api/ProductType/GetAllProductTypes', null);
    return response.data;
}

async function GetProductDetails(productcatogeryID) {
    const response = await CommonGet('/api/Product/GetAllProducts', 'productcatogeryID=' + parseInt(productcatogeryID));
    return response.data;
}

async function GetAllGroups() {
    const response = await CommonGet('/api/Group/GetAllGroups', null);
    return response.data;
}

async function GetFactoriesByGroupID(groupID) {
    const response = await CommonGet('/api/Factory/GetFactoriesByGroupID', 'groupID=' + parseInt(groupID));
    return response.data;
}

async function GetCropWiseCropForecast() {
    const response = await CommonGet('/api/ViewCropForecast/GetCropWiseCropForecast', null);
    return response.data;
}

async function GetCropForecastByOperationEntityID(operationEntityID) {
    const response = await CommonGet('/api/ViewCropForecast/GetCropForecastByOperationEntityIDComplex', 'operationEntityID=' + operationEntityID);
    return response.data;
}

async function GetCropForecastByCropID(CropID) {
    const response = await CommonGet('/api/ViewCropForecast/GetCropWiseCropForecast', 'CropID=' + CropID);
    return response.data;
}




